/* eslint-disable no-unused-vars */
import api from '../service/service'
import Swal from 'sweetalert2'
import Chart from 'chart.js'

export default {
  data () {
    return {
      People_count: 0,
      Family_count: 0,
      year: new Date().getFullYear(),
      myChartIncome: '',
      myChartexpenditure: '',
      myChartdebt: ''
    }
  },
  methods: {
    getFamily () {
      api.getFamilyCount(
        result => {
          if (result.result === true) {
            this.Family_count = result.data
          } else {
            Swal.fire('API Family Count Fail!', result.data, 'warning')
          }
        },
        error => {
          Swal.fire('API Family Count Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    getPeople () {
      api.getMemberCount(
        result => {
          if (result.result === true) {
            this.People_count = result.data
          } else {
            Swal.fire('API People Count Fail!', result.data, 'warning')
          }
        },
        error => {
          Swal.fire('API People Count Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    getReport () {
      api.getReportIncome({ year: this.year, month: '' },
        result => {
          if (result.result === true) {
            var month = []
            var income = []
            var expenditure = []
            var debt = []
            result.data.forEach(val => {
              month.push(this.monthFormat(val['month']))
              income.push(val['income'])
              expenditure.push(val['expenditure'])
              debt.push(val['debt'])
            })
            this.chartIncome(month, income)
            this.chartExpenditure(month, expenditure)
            this.chartDebt(month, debt)
            this.getFamily()
            this.getPeople()
          } else {
            Swal.fire('API People Count Fail!', result.data, 'warning')
          }
        },
        error => {
          Swal.fire('API Report Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    chartIncome (month, $data) {
      var ctx = document.getElementById('myChartIncome').getContext('2d')
      this.myChartIncome = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: month,
          datasets: [{
            label: 'ยอดรายรับของแต่ละเดือน ประจำปี ' + this.year,
            data: $data,
            backgroundColor: [
              'red',
              'red',
              'red',
              'red',
              'red',
              'red',
              'red',
              'red',
              'red',
              'red',
              'red',
              'red',
              'red'
            ],
            borderColor: [
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray'
            ],
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      })
    },
    chartExpenditure (month, $data) {
      var ctx = document.getElementById('myChartExpenditure').getContext('2d')
      this.myChartIncome = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: month,
          datasets: [{
            label: 'ยอดรายจ่ายของแต่ละเดือน ประจำปี ' + this.year,
            data: $data,
            backgroundColor: [
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4',
              '#4286f4'
            ],
            borderColor: [
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray'
            ],
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      })
    },
    chartDebt (month, $data) {
      var ctx = document.getElementById('myChartDebt').getContext('2d')
      this.myChartIncome = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: month,
          datasets: [{
            label: 'ยอดรายจ่ายของแต่ละเดือน ประจำปี ' + this.year,
            data: $data,
            backgroundColor: [
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4',
              '#cd41f4'
            ],
            borderColor: [
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray',
              'gray'
            ],
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      })
    }
  },
  mounted () {
    this.getReport()
  }
}



// WEBPACK FOOTER //
// ./src/js/Hello.js